import { Component, Input } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { TooltipPosition } from '@angular/material/tooltip';

@Component({
  selector: 'phoenix-info-helper',
  templateUrl: './info-helper.component.html',

  standalone: false,
})
export class InfoHelperComponent {
  /** Names the trigger: several helpers can share a page. */
  @Input() ariaLabel = 'info-helper-icon';

  @Input() tooltip = '';
  @Input() position: TooltipPosition = 'right';
  @Input() icon_material = 'info';
  @Input() icon_custom = '';
  @Input() link = '';
  @Input() isMenuHover = false;

  isHovering = false;

  timedOutCloser: NodeJS.Timeout | null = null;

  mouseEnter(trigger: MatMenuTrigger) {
    if (this.isMenuHover) {
      if (this.timedOutCloser) {
        clearTimeout(this.timedOutCloser);
        this.timedOutCloser = null;
      }
      trigger.openMenu();
    }
  }

  mouseLeave(trigger: MatMenuTrigger) {
    if (this.isMenuHover) {
      this.timedOutCloser = setTimeout(() => {
        trigger.closeMenu();
      }, 300);
    }
  }
}
